var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39209 16H3.42334C2.04481 16 0.92334 14.8785 0.92334 13.5V5.03125C0.92334 3.65272 2.04481 2.53125 3.42334 2.53125H9.39209C10.7706 2.53125 11.8921 3.65272 11.8921 5.03125V13.5C11.8921 14.8785 10.7706 16 9.39209 16ZM3.42334 3.78125C2.73412 3.78125 2.17334 4.34203 2.17334 5.03125V13.5C2.17334 14.1892 2.73412 14.75 3.42334 14.75H9.39209C10.0813 14.75 10.6421 14.1892 10.6421 13.5V5.03125C10.6421 4.34203 10.0813 3.78125 9.39209 3.78125H3.42334ZM14.3921 11.9375V2.5C14.3921 1.12147 13.2706 0 11.8921 0H4.95459C4.60937 0 4.32959 0.279781 4.32959 0.625C4.32959 0.970219 4.60937 1.25 4.95459 1.25H11.8921C12.5813 1.25 13.1421 1.81078 13.1421 2.5V11.9375C13.1421 12.2827 13.4219 12.5625 13.7671 12.5625C14.1123 12.5625 14.3921 12.2827 14.3921 11.9375Z",
    fill: "#f4694b"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.92334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.6565fac1d7c5aa1cfa0c7c397e3d3009.svg";
export { ForwardRef as ReactComponent };